import axios from 'src/app-axios';
import Constants from 'src/constants';

export const jobs = {
  namespaced: true,
  state: {
    pendingJobs: [],
    acceptedJobs: [],
    acceptedJobsCountByStatus: [],
    totalAcceptedJobs: null,
    jobDetails: {},
    subJobs: {},
    selectedFiles: null,
    comments: [],
    commentsTotal: 0,
    jobFilters: {},
    startPage: 0,
    load: false,
    buttonValue: false,
    jobCommentEvent: false,
  },
  getters: {
    getPendingJobs (state) {
      return state.pendingJobs;
    },
    getAcceptedJobs (state) {
      return state.acceptedJobs;
    },
    getJobCountsByStatus (state) {
      return state.acceptedJobsCountByStatus;
    },
    getTotalAcceptedJobs (state) {
      return state.totalAcceptedJobs;
    },
    getJobDetails (state) {
      return state.jobDetails;
    },
    getSubJobs (state) {
      return state.subJobs;
    },
    getSelectedFiles (state) {
      return state.selectedFiles;
    },
    getAllComments (state) {
      return state.comments;
    },
    getAllCommentsTotal (state) {
      return state.commentsTotal;
    },
    getJobFilters (state) {
      return state.jobFilters;
    },
    getPagination (state) {
      return state.startPage;
    },
    getLoadMore (state) {
      return state.load;
    },
    getButtonValue (state) {
      return state.buttonValue;
    },
    getJobCommentEvent (state) {
      return state.jobCommentEvent;
    },
  },
  mutations: {
    setPendingJobs (state, data) {
      state.pendingJobs = [...state.pendingJobs, ...data.data];
    },
    setAcceptedJobs (state, data) {
      state.acceptedJobs = [...state.acceptedJobs, ...data.data];
      state.totalAcceptedJobs = data.total;
    },
    setAcceptedJobCountsByStatus (state, data) {
      state.acceptedJobsCountByStatus = data;
    },
    clearAcceptedJobs (state) {
      state.acceptedJobs = [];
    },
    setJobDetails (state, data) {
      state.jobDetails = data;
    },
    setSubJobs (state, data) {
      state.subJobs = data;
    },
    setSelectedFiles (state, data) {
      state.selectedFiles = data;
    },
    deleteImage (state, index) {
      state.selectedFiles.splice(index, 1);
    },
    clearFiles (state) {
      state.selectedFiles = [];
    },
    setAllComments (state, comments) {
      state.comments = comments.data;
    },
    setAllCommentsTotal (state, comments) {
      state.commentsTotal = comments.total;
    },
    clearPendingJobs (state) {
      state.pendingJobs = [];
    },
    clearComments (state) {
      state.comments = [];
    },
    saveJobFilters (state, data) {
      state.jobFilters = data;
    },
    setButtonValue (state, data) {
      state.buttonValue = data;
    },
    setJobCommentEvent (state, data) {
      state.jobCommentEvent = data;
    },
  },
  actions: {
    async fetchAcceptedJobs ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.externalId}/jobs`;
      try {
        const data = await axios.get(url, payload.params);
        commit('setAcceptedJobs', data.data);
      } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting jobs.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        throw exception;
      }
    },
    async fetchAcceptedJobsCountByStatus ({ dispatch, commit }, payload) {
      const url = `api/devices/app-users/organizations/${payload.externalId}/job-counts`;
      try {
        const data = await axios.get(url, payload.params);
        commit('setAcceptedJobCountsByStatus', data.data);
      } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting job count.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        throw exception;
      }
    },
    async fetchPendingJobs ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.externalId}/job-requests`;
      try {
        const data = await axios.get(url, payload.params);
        commit('setPendingJobs', data.data);
      } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting the pending jobs.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        throw exception;
      }
    },
    async acceptedJobRequest ({ dispatch }, payload) {
      const url = `api/devices/jobs/job-requests/${payload.jobRequestId}`;
      try {
        await axios.put(url, payload.data);
      } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in updating this job.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        throw exception;
      }
    },
    async requestedDate ({ dispatch }, payload) {
      const url = `api/devices/jobs/job-requests/${payload.jobRequestId}`;
      try {
        await axios.put(url, payload.data);
      } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in updating this job.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        throw exception;
      }
    },
    async fetchJobDetails ({ dispatch, commit }, payload) {
      const url = `api/devices/jobs/${payload.jobId}`;
      try {
        const data = await axios.get(url);
        commit('setJobDetails', data.data);
      } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting this job details',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        throw exception;
      }
    },
    async fetchSubJobs ({ dispatch, commit }, payload) {
      const url = `api/devices/jobs/${payload.jobId}`;
      try {
        const data = await axios.get(url);
        commit('setSubJobs', data.data);
      } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting this job details',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        throw exception;
      }
    },
    setFiles ({ commit }, payload) {
      commit('setSelectedFiles', payload);
    },
    deleteSelectedImage ({ commit }, index) {
      commit('deleteImage', index);
    },
    clearSelectedFiles ({ commit }) {
      commit('clearFiles');
    },
    async fetchAllComments ({ dispatch, commit }, payload) {
      const url = `api/devices/jobs/${payload.jobId}/comments`;
      try {
        const data = await axios.get(url, payload.params);
        commit('setAllComments', data.data);
        commit('setAllCommentsTotal', data.data);
      } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting this job details',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        throw exception;
      }
    },
    async addComment ({ dispatch }, payload) {
      const url = `api/devices/organizations/${payload.orgId}/jobs/${payload.jobId}/comments`;
      try {
        await axios.post(url, payload.formData);
      } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting comments',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        throw exception;
      }
    },
    async saveProgress ({ dispatch }, payload) {
      const url = `api/devices/jobs/${payload.jobId}`;
      try {
        await axios.put(url, payload.formData);
      } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in updating job progress',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        throw exception;
      }
    },
    clearAppUserAcceptedJobs ({ commit }) {
      commit('clearAcceptedJobs');
    },
    clearAppUserPendingJobs ({ commit }) {
      commit('clearPendingJobs');
    },
    storeJobFilters ({ commit }, payload) {
      commit('saveJobFilters', payload);
    },
    clearJobComments ({ commit }) {
      commit('clearComments');
    },
    storeButtonValue ({ commit }, payload) {
      commit('setButtonValue', payload);
    },
    jobCommentEventOccured ({ commit }, payload) {
      commit('setJobCommentEvent', payload);
    },
  },
};
